module.exports = __webpack_public_path__ + "static/media/finnovexdark.1fcfd2b7.png";